// extracted by mini-css-extract-plugin
export var alt = "TermsOfServiceModal-module--alt--1a59b";
export var desktopOnly = "TermsOfServiceModal-module--desktopOnly--5a276";
export var main = "TermsOfServiceModal-module--main--3a388";
export var mobileOnly = "TermsOfServiceModal-module--mobileOnly--4dde9";
export var styledDialog = "TermsOfServiceModal-module--styledDialog--5fb51";
export var textLeft = "TermsOfServiceModal-module--textLeft--8e24d";
export var visuallyHidden = "TermsOfServiceModal-module--visuallyHidden--7219f";